import {
	ActionReducerMapBuilder,
	createSlice,
	isAnyOf,
	PayloadAction,
} from "@reduxjs/toolkit";
import { AreaInfoAppState } from "../../models/state/area-info-app-state";
import { searchApi } from "../../../system/redux/api/search-api";
import { searchQmiApi } from "../../../system/redux/api/search-qmi-api";
import { SearchApiResults } from "../../../system/redux/api/interfaces/search-api-results";

export const areaInfoSlice = createSlice({
	name: "areaInfo",
	initialState: {
		Name: "",
		Title: "",
		Url: "",
		Breadcrumb: "",
		AreaInfoContent: "",
		Latitude: 0,
		Longitude: 0,
		Zoom: 0,
		Radius: 0,
		OwningTeam: "",
	},

	reducers: {},
	extraReducers: (builder: ActionReducerMapBuilder<AreaInfoAppState>) => {
		builder.addMatcher(
			//This adds a listener to the getApiResults call, when that is fulfilled this code will be called
			//so we can process the results.
			isAnyOf(
				searchApi.endpoints.getApiResults.matchFulfilled,
				searchQmiApi.endpoints.getQmiApiResults.matchFulfilled
			),
			(state, action) => {
				let searchApiResults = action.payload as SearchApiResults;

				try {
					state.AreaInfoContent =
						searchApiResults.MetaData.AreaInfoData.AreaInfoContent;

					state.Url = searchApiResults.MetaData.AreaInfoData.Url;
					state.Breadcrumb = searchApiResults.MetaData.AreaInfoData.Breadcrumb;
					state.Title = searchApiResults.MetaData.AreaInfoData.Title;
					state.Name = searchApiResults.MetaData.AreaInfoData.Name;
					state.Latitude = searchApiResults.MetaData.AreaInfoData.Latitude;
					state.Longitude = searchApiResults.MetaData.AreaInfoData.Longitude;
					state.Zoom = searchApiResults.MetaData.AreaInfoData.ZoomLevel;
					state.Radius = searchApiResults.MetaData.AreaInfoData.Radius;
					state.OwningTeam = searchApiResults.MetaData.AreaInfoData.OwningTeam;
				} catch (exc) {
					console.log(
						"Area Info: searchApi.endpoints.getResults.matchFulfilled ERROR",
					);
					console.log(exc);
				}
			},
		);
	},
});

export const {} = areaInfoSlice.actions;

export default areaInfoSlice.reducer;
